import { render, staticRenderFns } from "./ConfigurationMenu.vue?vue&type=template&id=0108fc49&scoped=true"
import script from "./ConfigurationMenu.ts?vue&type=script&lang=ts&external"
export * from "./ConfigurationMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./ConfigurationMenu.vue?vue&type=style&index=0&id=0108fc49&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0108fc49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0108fc49')) {
      api.createRecord('0108fc49', component.options)
    } else {
      api.reload('0108fc49', component.options)
    }
    module.hot.accept("./ConfigurationMenu.vue?vue&type=template&id=0108fc49&scoped=true", function () {
      api.rerender('0108fc49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Alerts/components/ConfigurationMenu/ConfigurationMenu.vue"
export default component.exports